import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';

const LazyReferrals = lazy(() => import('./Referrals'));

export const Referrals: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyReferrals {...props} />
	</Suspense>
);
